<template>
    <div class="innerMainContent">
        <div class="innerHeader">
            <div class="h1Wrap">
                <svg class="i_users"><use xlink:href="#i_users"></use></svg>
                <div class="innerH1Wrap">
                    <h1>SMS</h1>
                    <ul class="breadcrumb">
                        <li><a href="#">ראשי</a></li>
                        <li class="active">SMS</li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-6 col-xs-12">
                <div class="innerBox">
                    <h2>
                        <span>מה תרצו לשלוח לאורחים שלכם?</span>
                        <svg class="i_info"><use xlink:href="#i_info"></use></svg>
                    </h2>
                    <ul class="nav nav-tabs tabsWrap">
                        <li class="active">
                            <a data-toggle="tab" href="#confirming_tab">
                                <svg class="i_event_tab"><use xlink:href="#i_event_tab"></use></svg>
                                <span>אישורי הגעה</span>
                            </a>
                        </li>
                        <li>
                            <a data-toggle="tab" href="#remainder_tab">
                                <svg class="i_offer_tab"><use xlink:href="#i_offer_tab"></use></svg>
                                <span>תזכורת</span>
                            </a>
                        </li>
                        <li>
                            <a data-toggle="tab" href="#thanks_tab">
                                <svg class="i_meeting_tab"><use xlink:href="#i_meeting_tab"></use></svg>
                                <span>תודה</span>
                            </a>
                        </li>
                    </ul>
                    <div class="tab-content">
                        <div id="confirming_tab" class="tab-pane fade in active">
                            <form action="" id="confirmingSms" class="formWrap">
                                <div class="row">
                                    <div class="col-xs-12">
                                        <div class="row">
                                            <div class="col-sm-6 col-xs-12">
                                                <div class="inputWrap">
                                                    <label for="title_1">כותרת</label>
                                                    <input type="text" id="title_1" name="title_1">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-xs-12">
                                                <div class="inputWrap textareaWrap">
                                                    <label for="msg_content_1">תוכן ההודעה</label>
                                                    <textarea name="msg_content_1" id="msg_content_1" class="noteWrapper"></textarea>
                                                    <span class="charsLength"><span class="charNum">200</span>/200</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-sm-6 col-xs-12">
                                                <div class="inputWrap">
                                                    <label for="step_1">פעימה 1</label>
                                                    <div class="selectWrap">
                                                        <select name="step_1" id="step_1">
                                                            <option value="0">שבועיים לפני</option>
                                                            <option value="1">3 שבועות לפני</option>
                                                        </select>
                                                        <svg class="i_select"><use xlink:href="#i_select"></use></svg>
                                                    </div>

                                                </div>
                                            </div>
                                            <div class="col-sm-6 col-xs-12">
                                                <div class="inputWrap">
                                                    <label for="step_2">פעימה 2</label>
                                                    <div class="selectWrap">
                                                        <select name="step_2" id="step_2">
                                                            <option value="0">יומיים לפני</option>
                                                            <option value="1">3 ימים לפני</option>
                                                        </select>
                                                        <svg class="i_select"><use xlink:href="#i_select"></use></svg>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-sm-6 pull-left">
                                                <div class="inputWrap submitWrap">
                                                    <button class="submit">שמור</button>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>

                            </form>
                        </div>
                        <div id="remainder_tab" class="tab-pane fade">
                            <form action="" id="confirmingSms_2" class="formWrap">
                                <div class="row">
                                    <div class="col-xs-12">
                                        <div class="row">
                                            <div class="col-sm-6 col-xs-12">
                                                <div class="inputWrap">
                                                    <label for="address_1">כתובת למקום</label>
                                                    <input type="text" id="address_1" name="address_1">
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-xs-12">
                                                <div class="inputWrap textareaWrap">
                                                    <label for="msg_content_2">תוכן ההודעה</label>
                                                    <textarea name="msg_content_2" id="msg_content_2" class="noteWrapper"></textarea>
                                                    <span class="charsLength"><span class="charNum">200</span>/200</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-sm-6 pull-left">
                                                <div class="inputWrap submitWrap">
                                                    <button class="submit">שמור</button>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </form>
                        </div>
                        <div id="thanks_tab" class="tab-pane fade">
                            <form action="" id="confirmingSms_3" class="formWrap">
                                <div class="row">
                                    <div class="col-xs-12">
                                        <div class="row">
                                            <div class="col-xs-12">
                                                <div class="inputWrap textareaWrap">
                                                    <label for="msg_content_2">תוכן ההודעה</label>
                                                    <textarea name="msg_content_2" id="msg_content_2" class="noteWrapper"></textarea>
                                                    <span class="charsLength"><span class="charNum">200</span>/200</span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="row">
                                            <div class="col-sm-6 pull-left">
                                                <div class="inputWrap submitWrap">
                                                    <button class="submit">שמור</button>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-6 col-xs-12">
                <div class="innerBox">
                    <h2>
                        <span>איזה סגנון אתם אוהבים?</span>
                        <svg class="i_info"><use xlink:href="#i_info"></use></svg>
                    </h2>
                    <div id="imageCarusel" class="owl-carousel owl-theme" data-carousel='{"items":3,"nav":true,"dots":true,"loop":true,"center":true,"autoplay":false,"smartSpeed":700,"navText":["<span class=\"sr-only\">הקודם</span><svg class=\"i_select\"><use xlink:href=\"#i_select\"></use></svg>","<span class=\"sr-only\">הבא</span><svg class=\"i_select\"><use xlink:href=\"#i_select\"></use></svg>"],"navElement":"button","rtl":true}'>
                        <div class="imageWrap">
                            <img src="https://dummyimage.com/225x340/bfc0c7/bfc0c7" alt="">
                            <div class="hoverEl"><svg><use xlink:href="#i_v"></use></svg></div>
                        </div>
                        <div class="imageWrap">
                            <img src="https://dummyimage.com/225x340/bfc0c7/bfc0c7" alt="">
                        </div>
                        <div class="imageWrap">
                            <img src="https://dummyimage.com/225x340/bfc0c7/bfc0c7" alt="">
                        </div>
                        <div class="imageWrap">
                            <img src="https://dummyimage.com/225x340/bfc0c7/bfc0c7" alt="">
                        </div>
                    </div>

                </div>
                <div class="innerBox inviteBox">
                    <div class="textSide">
                        <h2>
                            <span>תמונה להזמנה</span>
                            <svg class="i_info"><use xlink:href="#i_info"></use></svg>
                        </h2>
                        <div class="body">איזה תמונה תרצו שתופיע על בהזמנה
                            לאירוע שלכם?</div>
                    </div>
                    <div class="imgSide">
                        <img src="/static/images/zug.jpg" alt="">
                    </div>
                </div>
            </div>
        </div>


    </div>
</template>

<script>
    export default {
        name: "SMS",
        mounted(){
            $(document).ready(function() {
                $.getScript( "/static/js/owl.carousel.min.js",function() {
                    function initCarousel(obj, opts) {
                        $(obj).owlCarousel(opts);
                        let pp = $(obj).data("pp");
                        if (pp) {
                            if (pp == ".playPauseWrapper") {
                                $(".playPauseWrapper").append("<button class='playPauseBtn'><svg class='i_play'><use xlink:href='#i_play'></use></svg><svg class='i_pause'><use xlink:href='#i_pause'></use></svg><span class='sr-only'>עצור גלריה אוטמטית</span></button>");
                            } else {
                                if (pp == ".owl-nav") {
                                    $(obj).find('.owl-nav').find('.owl-prev').after("<button class='playPauseBtn'><svg class='i_play'><use xlink:href='#i_play'></use></svg><svg class='i_pause'><use xlink:href='#i_pause'></use></svg><span class='sr-only'>עצור גלריה אוטמטית</span></button>");
                                } else {
                                    $(obj).find(pp).prepend("<button class='playPauseBtn'><svg class='i_play'><use xlink:href='#i_play'></use></svg><svg class='i_pause'><use xlink:href='#i_pause'></use></svg><span class='sr-only'>עצור גלריה אוטמטית</span></button>");
                                }
                            }
                            $(obj).parent().find('.playPauseBtn').click(function (e) {
                                if ($(this).hasClass('paused')) {
                                    obj.trigger('play.owl.autoplay');
                                    $(this).removeClass("paused");
                                    $(this).find('span').html("עצור גלריה אוטמטית");
                                } else {
                                    obj.trigger('stop.owl.autoplay', [1000]);
                                    $(this).addClass("paused");
                                    $(this).find('span').html("הפעל גלריה אוטמטית");
                                }
                            });
                        }

                    }

                    $(".owl-carousel[data-carousel]:not(.manual)").each(function () {
                        $(this).owlCarousel($(this).data("carousel"))
                    });

                });
            });

        }
    }
</script>
